import {
    LocalizationContextBuilder,
    MessageBundle,
    LocalizationContext,
} from '@amzn/arb-tools';
import translations from 'translations';
import { DEFAULT_LOCALE } from './i18n/i18nConfig';

const LOCALIZATION_CONTEXTS = new Map<string, LocalizationContext>();

export function getLocalizationContext(locale: string) {
    let lc = LOCALIZATION_CONTEXTS.get(locale);
    if (!lc) {
        lc = new LocalizationContextBuilder()
            .withLocale(locale)
            .withDefaultLocale(DEFAULT_LOCALE)
            .build();
        LOCALIZATION_CONTEXTS.set(locale, lc);
    }
    return lc;
}

export function t(bundle: MessageBundle | undefined, stringId: string, args?: Record<string, any>): string {
    if (!bundle) {
        return stringId;
    }

    if (args) {
        return bundle.formatMessage(stringId, args);
    }

    return bundle.getMessage(stringId);
}

export function getMbmOptions(arbManifest: {
    endpointMap: Record<string, Record<string, string>>;
}) {
    let currentLocale = DEFAULT_LOCALE;
    const documentLocale = document?.querySelector('html')?.getAttribute('lang');
    if (documentLocale) {
        currentLocale = documentLocale;
    }

    const localizationContext = getLocalizationContext(currentLocale);

    return {
        arbManifest,
        defaultLocalizationContext: localizationContext,
        resolveBundleUrl: (
            resourcePackPath: string | undefined,
            locale: string,
            bundle: string
        ) => resolveBundleUrlWithFallbacks(arbManifest, resourcePackPath, locale, bundle),
    };
}

export function resolveBundleUrlWithFallbacks(
    arbManifest: { endpointMap: Record<string, Record<string, string>> },
    resourcePackPath: string | undefined,
    locale: string,
    bundle: string
) {
    if (resourcePackPath && translations[resourcePackPath]) {
        return translations[resourcePackPath];
    }

    if (!resourcePackPath && arbManifest.endpointMap?.[locale]?.[bundle]) {
        return translations[arbManifest.endpointMap[locale][bundle]];
    }

    if (arbManifest.endpointMap?.[DEFAULT_LOCALE]?.[bundle]) {
        return translations[arbManifest.endpointMap[DEFAULT_LOCALE][bundle]];
    }

    return undefined;
}
